import { MediaTypePostEditorState } from '../../../../models/post-editor';
import { MediaType, PostMultiMediaAttachMode } from '../../../../models/graphql';
import { MAX_MEDIA_CONFIG } from './validators-constants';

export const getMediaConfigValidation = (
  network: 'google' | 'pinterest' | 'twitter' | 'facebook' | 'instagram' | 'linkedin' | 'tiktok',
  media: MediaTypePostEditorState[],
  varyMedia: PostMultiMediaAttachMode | null
) => {
  let invalidImages = false;
  let invalidGifs = false;
  let invalidVideos = false;
  if (!media.length || varyMedia === PostMultiMediaAttachMode.ALTERNATE) {
    return { invalidImages, invalidGifs, invalidVideos };
  }
  const imagesLength = media.filter(m => m.type === MediaType.PHOTO && !m.gif).length;
  const gifsLength = media.filter(m => m.type === MediaType.PHOTO && m.gif).length;
  const videosLength = media.filter(m => m.type === MediaType.VIDEO).length;
  if (network !== 'google' && network !== 'tiktok') {
    invalidImages = imagesLength > MAX_MEDIA_CONFIG.image[network];
    invalidGifs = gifsLength > MAX_MEDIA_CONFIG.gif[network];
    invalidVideos = videosLength > MAX_MEDIA_CONFIG.video[network];
  } else if (network === 'tiktok') {
    invalidVideos = media.length > MAX_MEDIA_CONFIG[network] && !gifsLength && !imagesLength;
  } else {
    invalidImages = media.length > MAX_MEDIA_CONFIG[network] && !gifsLength && !videosLength;
  }
  return { invalidImages, invalidGifs, invalidVideos };
};
